var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "related-products" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c("div", { staticClass: "top" }, [
          _c("span", { staticClass: "back", on: { click: _vm.goBack } }, [
            _c("i", {
              staticClass: "iconfont icon-fanhui",
              staticStyle: { "font-size": "24px" },
            }),
          ]),
          _c("span", { staticClass: "title" }, [_vm._v("关联产品")]),
        ]),
      ]),
    ]),
    _c(
      "div",
      [
        _c("div", { staticClass: "detail-box" }, [
          _c("div", [
            _c("span", { staticClass: "label" }, [_vm._v("固件名称")]),
            _vm._v("\n        " + _vm._s(_vm.name) + "\n      "),
          ]),
          _c("div", [
            _c("span", { staticClass: "label" }, [_vm._v("固件Key")]),
            _vm._v(
              "\n        " + _vm._s(_vm.formSearch.componentId) + "\n      "
            ),
          ]),
        ]),
        _c(
          "el-form",
          { ref: "form", staticClass: "search-form", attrs: { inline: true } },
          [
            _c(
              "el-col",
              { attrs: { span: 24 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "产品名称" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入固件名称", clearable: "" },
                      model: {
                        value: _vm.formSearch.productName,
                        callback: function ($$v) {
                          _vm.$set(_vm.formSearch, "productName", $$v)
                        },
                        expression: "formSearch.productName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "产品ID" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入产品ID", clearable: "" },
                      model: {
                        value: _vm.formSearch.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formSearch, "productId", $$v)
                        },
                        expression: "formSearch.productId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "14" },
                    on: {
                      click: function ($event) {
                        return _vm.relatedProductsList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              "header-cell-style": { background: "#F5F6F7" },
              size: "medium",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "productName", label: "产品名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productId", label: "产品ID" },
            }),
            _c("el-table-column", {
              attrs: { prop: "version", label: "固件版本" },
            }),
            _c("el-table-column", {
              attrs: { prop: "bindCreateTime", label: "关联时间" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productCreateTime", label: "产品创建时间" },
            }),
          ],
          1
        ),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 30, 40],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }